import { FC } from 'react'

type BalanceIconProps = {}

const BalanceIcon: FC<BalanceIconProps> = ({}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 18V21M12 18H13C14.6569 18 16 16.6569 16 15C16 13.3431 14.6569 12 13 12H11C9.34315 12 8 10.6569 8 9C8 7.34315 9.34315 6 11 6H12M12 18H11C9.34315 18 8 16.6569 8 15M12 6V3M12 6H13C14.6569 6 16 7.34315 16 9"
        stroke="#2B2F33"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default BalanceIcon
